import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SpinnerService } from "@core/spinner.service";
import { environment } from "@env/environment";
import { catchError, finalize, Observable, throwError } from "rxjs";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private totalRequests = 0;
  private redirectToLogin = false;

  constructor(private spinnerService: SpinnerService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const requestWithSpinner = !req.headers.has(InterceptorSkipHeader);

    if (requestWithSpinner) {
      this.totalRequests++;
      this.spinnerService.show();
    }

    const reqWithCredentials = req.clone({
      withCredentials: true,
      headers: req.headers.delete(InterceptorSkipHeader),
    });

    return next.handle(reqWithCredentials).pipe(
      catchError((error: HttpErrorResponse) => {
        const url = req.url ?? '';
        const isAuthEndpoint = url.includes('/oidc/login') ||
          url.includes('/oauth2/') ||
          url.includes('/login/oauth2/');
        if (error.status === 401 && !isAuthEndpoint && !this.redirectToLogin) {
          this.redirectToLogin = true;
          window.location.replace('/oidc/login');
        }
        return throwError(() => error);
      }),
      finalize(() => {
        if (requestWithSpinner) {
          this.totalRequests--;

          if (this.totalRequests <= 0) {
            this.spinnerService.hide();
          }
        }
      })
    )
  }
}

export const InterceptorSkipHeader = 'X-Skip-Interceptor';
export const spinnerlessheader = {
  headers: new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set(InterceptorSkipHeader, 'true'),
}
